import { createRoutine } from 'redux-saga-routines';
import { LIST_PARENT_SOURCES, LIST_SOURCES, RETRIEVE_SOURCE } from './types';

export const listSources = createRoutine(LIST_SOURCES);
export const listParentSources = createRoutine(LIST_PARENT_SOURCES);
export const retrieveSource = createRoutine(RETRIEVE_SOURCE);
